<!-- 学员管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="sxBox">
        <el-tabs v-model="queryInfoType" @tab-click="handleClick">
          <el-tab-pane label="自有号码" name="2"></el-tab-pane>
          <el-tab-pane label="平台号码" name="1"></el-tab-pane>
        </el-tabs>

        <el-button class="screenShow" @click="screen()" type="text"
          >筛选</el-button
        >
      </div>
      <div class="querySearch">
        <div class="searchItem">
          <span>手机号码：</span>
          <el-input
            class="w300"
            v-model="queryInfo.mobile"
            clearable
            size="small"
            placeholder="请输入学员手机号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>姓名：</span>
          <el-input
            class="w300"
            v-model="queryInfo.fullname"
            clearable
            size="small"
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>任务名称：</span>
          <el-select
            v-model="queryInfo.task_ids"
            filterable
            placeholder="请选择任务"
            :clearable="true"
            size="mini"
            @change="taskChange"
          >
            <el-option
              v-for="item in nameOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>负责人：</span>
          <el-select
            v-model="queryInfo.staff_id"
            filterable
            placeholder="请选择负责人"
            :clearable="true"
            size="mini"
            @change="staffChange"
          >
            <el-option
              v-for="item in principalOptions"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="searchItem">
          <span>考试</span>

          <el-input
            class="w300"
            v-model="queryInfo.exam"
            clearable
            size="small"
            placeholder="请输入考试"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>标签</span>
          <el-select
            v-model="selectTags"
            filterable
            remote
            multiple
            reserve-keyword
            placeholder="请输入关键词"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item, index) in options1"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>跟进状态：</span>
          <el-select v-model="queryInfo.status" size="small" class="w150Select">
            <el-option label="请选择状态" value="-1"></el-option>
            <!-- 0未联系 1已接通 2未接通 -->
            <el-option label="未联系" :value="0"></el-option>
            <el-option label="已接通" :value="1"></el-option>
            <el-option label="未接通" :value="2"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>省份：</span>
          <el-select
            v-model="selectedProvinces"
            size="small"
            class="w150Select"
            clearable
            multiple
            filterable
            @change="provinceChange"
          >
            <el-option
              v-for="(item, index) in provincesOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>城市：</span>
          <el-select
            v-model="selectedCitys"
            size="small"
            class="w150Select"
            clearable
            multiple
            filterable
            :disabled="selectedProvinces.length > 1"
          >
            <el-option
              v-for="(item, index) in citysOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div v-if="!launchStatus" class="searchItem">
          <span>备注：</span>
          <el-input
            class="w300"
            v-model="queryInfo.remark"
            clearable
            size="small"
            placeholder="请输入备注信息"
          ></el-input>
        </div>
        <div v-if="!launchStatus" class="searchItem">
          <span>导入时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        
        <div v-if="!launchStatus" class="searchItem">
          <span>手机号注册时间：</span>
          <el-date-picker
            v-model="timeFrame2"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData2"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

 

        <launchSelect @launchStatusChang="launchStatusChang"></launchSelect>

        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="(queryInfo.page = 1), queryTable()"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery(queryInfo.type)"
        ></MyButton>
      </div>
      <div class="addInfo" v-if="myUser && myUser.group.is_call == 1">
        <div
          v-if="is_show_task && queryInfoType == 2"
          style="margin-right: 30px; display: inline-block"
        >
          创建任务
          <el-button type="success" size="small" @click="openImport"
            >导入自有号码</el-button
          >
          <el-popover
            placement="top-start"
            title=""
            width="200"
            trigger="hover"
            :content="selfnumber"
          >
            <!-- <i class="el-icon-question el-icon--right" slot="reference"></i> -->

            <i class="el-icon--right questionIcon" slot="reference"></i>
          </el-popover>
        </div>
        <div
          v-if="role == 'admin' && queryInfoType == 1"
          style="margin-right: 30px; display: inline-block"
        >
          创建任务
          <el-button type="warning" size="small" @click="openKefu()"
            >导入平台号码</el-button
          >
          <el-popover
            placement="top-start"
            title=""
            width="200"
            trigger="hover"
            :content="preciseimport"
          >
            <!-- <i class="el-icon-question el-icon--right" slot="reference"></i> -->
            <i class="el-icon--right questionIcon" slot="reference"></i>
          </el-popover>
        </div>

        <el-button
          type="primary"
          size="small"
          @click="changeMobile()"
          style="margin-right: 10px; display: inline-block"
          >当前绑定号码
          {{ myUser.call_phone ? myUser.call_phone : myUser.mobile }}
          <i class="el-icon-edit el-icon--right"></i>
        </el-button>
        <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="outboundcallnumber"
          style="margin-right: 10px; display: inline-block"
        >
          <!-- <i class="el-icon-question el-icon--right" slot="reference"></i> -->
          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>

        <div
          v-if="role == 'admin'"
          style="margin-right: 10px; display: inline-block"
        >
          <el-button type="primary" size="small" @click="batchTransfer()"
            >批量转移客户
          </el-button>

          <el-popover placement="top-start" width="200" trigger="hover">
            <div v-html="billingzysm"></div>
            <!-- <i
            class="el-icon-question el-icon--right"
            slot="reference"
            style="margin: 0 30px 0 10px"
          ></i> -->
            <i
              class="el-icon--right questionIcon"
              style="margin: 0 30px 0 10px"
              slot="reference"
            ></i>
          </el-popover>

          <el-button
            v-if="role == 'admin'"
            type="danger"
            size="small"
            @click="downloadExcel"
            >导出Excel</el-button
          >
          <el-popover placement="top-start" width="200" trigger="hover">
            <div v-html="outbounddcgzsm"></div>
            <!-- <i
            class="el-icon-question el-icon--right"
            slot="reference"
            style="margin: 0 30px 0 10px"
          ></i> -->
            <i
              class="el-icon--right questionIcon"
              style="margin: 0 30px 0 10px"
              slot="reference"
            ></i>
          </el-popover>
        </div>

        <div v-if="queryInfoType == 2" style="float: right">
          <el-popover
            placement="bottom"
            trigger="click"
            v-model="revealVisible"
          >
            <div>
              <p>可勾掉不需要显示的列表数据</p>
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="popoverChecked"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="item in popoverOptions"
                  :key="item.field"
                  style="display: block"
                  :label="item.field"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>

              <div slot="footer" class="dialog-footer" style="margin-top: 20px">
                <el-button @click="revealVisible = false" size="mini"
                  >取 消</el-button
                >
                <el-button type="primary" @click="confirm" size="mini"
                  >确 定</el-button
                >
              </div>
            </div>
            <el-button slot="reference">显示列表设置</el-button>
          </el-popover>
        </div>
      </div>

      <div
        v-if="role == 'admin'"
        style="margin-bottom: 10px; margin-left: 10px"
      >
        <el-checkbox v-model="currentData" @change="currentChange"
          >当前页</el-checkbox
        >
        <el-checkbox v-model="ownData" @change="ownChange">所有页</el-checkbox>
      </div>
      <div
        class="table"
        v-if="myUser && myUser.group.is_call == 1 && tableList.length > 0"
      >
        <el-table
          ref="multipleTable"
          :data="tableList"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            v-if="role == 'admin'"
            type="selection"
            width="55"
            align="center"
          ></el-table-column>

          <el-table-column
            v-if="tableList[0].type_is_show"
            prop="type"
            label="号码类型"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "平台号码" : "自有号码" }}
            </template>
          </el-table-column>
          <el-table-column prop="task_name" label="任务名称" align="center" />
          <el-table-column
            v-if="queryInfoType == 2 && tableList[0].fullname_is_show"
            prop="fullname"
            label="姓名"
            align="center"
          />
          <el-table-column prop="mobile" label="手机号" align="center" />
          <el-table-column
            v-if="queryInfoType == 2 && tableList[0].score_is_show"
            prop="score"
            label="分数"
            align="center"
          />
          <el-table-column
            v-if="tableList[0].app_type_is_show || queryInfoType == 1"
            prop="exam"
            label="所属考试"
            align="center"
          />
          <el-table-column
            v-if="tableList[0].province_name_is_show || queryInfoType == 1"
            prop="province_name"
            label="省份"
            align="center"
          />
          <el-table-column
            v-if="tableList[0].city_name_is_show || queryInfoType == 1"
            prop="city_name"
            label="市"
            align="center"
          />
          <el-table-column prop="tags" label="标签" align="center">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="hover"
                v-if="scope.row.tags && scope.row.tags.length > 3"
              >
                <div style="width: 300px">
                  <el-tag
                    v-for="(item, index) in scope.row.tags"
                    :key="index"
                    style="
                      margin: 5px;
                      max-width: 100%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                    >{{ item }}</el-tag
                  >
                </div>
                <div slot="reference">
                  <div @click="editLabel(scope.row)">
                    <el-tag
                      v-for="(item, index) in scope.row.tags"
                      :key="index"
                      style="margin: 5px"
                      v-show="index < 3"
                      >{{ item }}</el-tag
                    >
                    ...
                  </div>
                </div>
              </el-popover>
              <div v-else-if="scope.row.tags && scope.row.tags.length > 0">
                <el-tag
                  v-for="(item, index) in scope.row.tags"
                  :key="index"
                  style="margin: 5px"
                  @click="editLabel(scope.row)"
                  >{{ item }}</el-tag
                >
              </div>
              <el-button v-else type="text" @click="editLabel(scope.row)"
                >添加</el-button
              >
            </template>
          </el-table-column>

          <el-table-column prop="status" label="跟进状态" align="center">
            <template slot-scope="scope">
              <!-- 0未联系 1已接通 2未接通 -->
              <div v-if="scope.row.status == 0">未联系</div>
              <div v-else-if="scope.row.status == 1">
                已接通<span
                  style="cursor: pointer; color: cornflowerblue"
                  @click="openCallLogs(scope.row)"
                  >（{{ scope.row.status_data.call_succ }}/{{
                    scope.row.status_data.call_total
                  }}）查看</span
                >
              </div>
              <div v-else-if="scope.row.status == 2">
                未接通
                <span
                  style="cursor: pointer; color: cornflowerblue"
                  @click="openCallLogs(scope.row)"
                  >（{{ scope.row.status_data.call_succ }}/{{
                    scope.row.status_data.call_total
                  }}）查看</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
            <template slot-scope="scope">
              <div
                style="
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                "
              >
                {{ scope.row.remark }}
              </div>

              <el-button @click="viewDetail(scope.row)" type="text">{{
                scope.row.remark ? "查看更多" : "添加备注"
              }}</el-button>
            </template>
          </el-table-column> 
          <el-table-column prop="form_date" label="表单日期" align="center" /> 
          <el-table-column prop="mobile_at" label="手机号码注册时间" align="center" />  
          <el-table-column
            v-if="tableList[0].import_at_is_show || queryInfoType == 1"
            prop="import_at"
            label="导入时间"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="staff_name" label="负责人" align="center" />
          <el-table-column
            prop="last_call_at"
            label="最近一次呼叫时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="操作"
            align="center"
            width="220"
            fixed="right"
          >
            <template slot-scope="scope"> 
              <span
                class="operationItemNew"
                @click="callPhoneOpen(scope.row, scope.$index)"
                >呼叫</span
              >
              <span style="color: #e7eaf0; padding: 0 10px">|</span>
              <span class="operationItem" @click="viewDetail(scope.row)"
                >备注</span
              >
              <span style="color: #e7eaf0; padding: 0 10px">|</span>
              <span class="operationItem" @click="transfer(scope.row)"
                >转移</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="pagination"
        v-if="myUser && myUser.group.is_call == 1 && tableList.length > 0"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
      <!--空数据情况-->
      <div
        v-if="
          myUser &&
          queryInfoType == 2 &&
          myUser.group.is_call == 1 &&
          tableList.length <= 0
        "
        style="display: flex; flex-direction: column; align-items: center"
      >
        <div>
          <el-empty
            v-if="role == 'admin'"
            description="暂无客户数据，请点击创建拨号任务"
          />
          <el-empty
            v-else
            description="暂无自有号码客户数据，请联系机构管理员分配"
          />
        </div>
        <el-button v-if="role == 'admin'" type="primary" @click="openImport()"
          >导入自有号码</el-button
        >
        <el-button v-else type="primary" @click="openKefu()"
          >立即联系导入</el-button
        >
      </div>
      <div
        v-if="
          myUser &&
          queryInfoType == 1 &&
          myUser.group.is_call == 1 &&
          tableList.length <= 0
        "
        style="
          padding-top: 50px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <div>
          <el-empty
            v-if="role == 'admin'"
            description="暂无平台客户数据，请联系平台负责导入"
          />
          <el-empty
            v-else
            description="暂无平台号码客户数据，请联系机构管理员分配"
          />
        </div>
        <el-button type="primary" @click="openKefu()">立即联系导入</el-button>
      </div>
    </div>

    <!-- 通话记录弹窗 -->
    <el-dialog
      title=""
      :visible.sync="callLogDialogVisible"
      class="formDialog"
      width="80%"
    >
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <span>被叫号码: {{ callData.mobile }}</span>
        <el-button type="text" @click="jifeiDialogVisible = true"
          >计费说明
          <!-- <i class="el-icon-question el-icon--right"></i> -->

          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-button>
      </div>
      <div class="table" style="min-height: 0">
        <TableComponents
          :columns="callLogColumns"
          :tableData="callLogTableData"
        >
          <!-- 学员标签管理 -->
          <template slot="studentLabel" slot-scope="{ row }">
            <el-popover
              placement="right"
              trigger="hover"
              v-if="row.tags && row.tags.length > 3"
            >
              <div style="width: 200px">
                <el-tag
                  v-for="(item, index) in row.tags"
                  :key="index"
                  style="margin: 5px"
                  >{{ item }}</el-tag
                >
              </div>
              <div slot="reference">
                <div @click="editLabel(row)">
                  <el-tag
                    v-for="(item, index) in row.tags"
                    :key="index"
                    style="margin: 5px"
                    v-show="index < 3"
                    >{{ item }}</el-tag
                  >
                  ...
                </div>
              </div>
            </el-popover>
            <div v-else-if="row.tags && row.tags.length > 0">
              <el-tag
                v-for="(item, index) in row.tags"
                :key="index"
                style="margin: 5px"
                >{{ item }}</el-tag
              >
            </div>
          </template>
          <template slot="price" slot-scope="{ row }">
            ￥{{ row.price / 100 }}
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="callLogQuery.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="callLogQuery.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="callLogQuery.total"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 新增备注弹窗 -->
    <el-dialog
      title="添加备注"
      :visible.sync="addFormShow"
      class="formDialog"
      width="60%"
      @close="addFormClose"
    >
      <el-form :model="remarkData" label-width="80px">
        <el-form-item label="备注：">
          <el-input
            v-model="remarkData.remark"
            placeholder="请输入备注"
            size="mini"
            maxlength="50"
            show-word-limit
            type="textarea"
            style="width: 100%"
            @input="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <div style="text-align: right">
          <el-button type="primary" @click="addRemark()" size="mini"
            >添加备注</el-button
          >
        </div>
        <div v-if="remarkList && remarkList.length > 0" class="remarkList">
          <div
            class="remarkItem"
            v-for="(item, index) in remarkList"
            :key="index"
          >
            <div v-if="item.editStatus">
              <!-- 编辑备注 -->
              <div class="editRemark">
                <el-input
                  v-model="item.remark"
                  placeholder="请输入备注"
                  size="mini"
                  maxlength="50"
                  show-word-limit
                  type="textarea"
                  style="width: 100%"
                  @input="$forceUpdate()"
                ></el-input>
              </div>
              <div class="bt">
                <el-button type="text" @click="remarkCancel(item)"
                  >取消</el-button
                >
                <el-button type="text" @click="remarkSave(item)"
                  >保存</el-button
                >
              </div>
            </div>
            <div v-else>
              <div class="remark">{{ item.remark }}</div>
              <div class="name">{{ item.txt }}</div>
              <div class="bt" v-if="userInfoId == item.staff_id">
                <el-button type="text" @click="remarkEdit(item, index)"
                  >编辑</el-button
                >
                <el-button type="text" @click="remarkDelete(item)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUserRemark()" size="mini"
          >确 定</el-button
        >
        <el-button @click="addFormShow = false" size="mini">取 消</el-button>
      </div> -->
    </el-dialog>
    <!-- 呼叫弹窗 -->
    <callPhonePopUp
      v-if="callDialogVisible"
      :callDialogVisible="callDialogVisible"
      @closeCallPop="closeCallPop($event)"
      @callNext="callNext"
      @openKefu="openKefu"
      :callUser="callUser"
      :key="callUser.id"
      :myUser="myUser" 
    ></callPhonePopUp>  
    <!-- 呼叫状态弹窗 -->
    <el-dialog
      title=""
      :visible.sync="callStatusDialogVisible"
      class="formDialog"
      width="60%"
      @close="callDialogClose()"
    >
      <span>被叫号码：{{ callUser.mobile }}</span>
      <div
        v-if="callStatus == -1"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <span style="font-size: 30px">所剩余额不足，暂时无法呼叫</span>
        <div style="font-size: 22px; padding-bottom: 20px">
          （帐户余额不能小于<span style="color: red">{{
            callErrorData.lowest_limit_price
          }}</span
          >)
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="openKefu()">去充值</el-button>
        </div>
      </div>
      <div v-else-if="callStatus == 0">
        <div style="padding-top: 20px; font-size: 30px; text-align: center">
          正在拨号中...
        </div>
      </div>
      <!--已挂断-->
      <div
        v-else-if="callStatus == 1"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <span style="font-size: 30px; padding-bottom: 20px">已挂断</span>
        <span>通话时长：{{ callSuccessData.call_duration_txt }}</span>
        <div
          style="
            display: flex;
            flex-direction: row;
            padding-top: 20px;
            padding-bottom: 20px;
          "
        >
          <span>总计费用：</span>
          <div v-if="callSuccessData.is_pay == 1">
            {{ callSuccessData.compute_time }}*{{
              callSuccessData.compute_ceil_price
            }}=<span style="color: red"
              >{{ callSuccessData.compute_total_price }}元</span
            >
          </div>
          <div v-else>
            {{ callSuccessData.compute_total_price
            }}<span
              style="color: red"
              v-if="callSuccessData.import_user_first_free_txt"
              >({{ callSuccessData.import_user_first_free_txt }})</span
            >
          </div>
        </div>
        <el-button type="primary" @click="callPhoneOpen()">重拨</el-button>
      </div>
    </el-dialog>
    <!-- 客服弹窗 -->
    <el-dialog
      title=""
      :visible.sync="kefuDialogVisible"
      class="formDialog"
      width="60%"
    >
      <div
        v-if="role == 'admin'"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <span>技术对接和充值：{{ kefuData.teacher_name }}</span>
        <span
          v-if="kefuData && kefuData.teacher_mobile"
          style="padding-bottom: 20px; padding-top: 20px"
          >联系方式：{{ kefuData.teacher_mobile }}</span
        >
        <div v-if="kefuData.qrcode">
          <span style="padding-bottom: 20px">微信咨询 扫码联系</span>
          <el-image
            style="width: 100px; height: 100px"
            :src="kefuData.qrcode"
            :preview-src-list="[kefuData.qrcode]"
          />
        </div>
      </div>
      <div
        v-else
        style="display: flex; flex-direction: column; align-items: center"
      >
        <span>技术对接和充值：{{ kefuData2.contact_realname }}</span>
        <span
          v-if="kefuData2.contact_mobile"
          style="padding-bottom: 20px; padding-top: 20px"
          >联系方式：{{ kefuData2.contact_mobile }}</span
        >
        <div v-if="kefuData2.wechat_code">
          <span style="padding-bottom: 20px">微信咨询 扫码联系</span>
          <el-image
            style="width: 100px; height: 100px"
            :src="kefuData2.wechat_code"
            :preview-src-list="[kefuData2.wechat_code]"
          />
        </div>
      </div>
    </el-dialog>
    <!-- 修改号码弹窗 -->
    <el-dialog
      title="修改号码"
      :visible.sync="changeMobileDialogVisible"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userInfoForm"
        label-width="100px"
      >
        <el-form-item label="当前号码：">
          {{ myCallPhone }}
        </el-form-item>
        <el-form-item label="新号码：" required>
          <el-input
            v-model="newCallPhone"
            placeholder="请输入新号码"
            size="mini"
            maxlength="11"
            show-word-limit
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeMobileCheck()" size="mini"
          >保存</el-button
        >
        <el-button @click="changeMobileDialogVisible = false" size="mini"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加标签弹窗 -->
    <el-dialog
      title="编辑标签"
      :visible.sync="editLabelShow"
      class="formDialog"
      width="50%"
    >
      <div class="editLabelClass">
        <div class="p1">已添加标签</div>
        <div class="p2">
          <el-tag
            v-for="(tag, index) in userLabel"
            :key="index"
            closable
            @close="deleteLabel(tag)"
          >
            {{ tag.name }}
          </el-tag>
        </div>
      </div>
      <div class="editLabelClass">
        <div class="p1">可添加标签</div>
        <div class="p2">
          <el-tag
            v-for="(tag, _index) in addLabel"
            type="success"
            :key="_index"
            @click="tagAddLabel(tag)"
          >
            {{ tag.name }}
          </el-tag>
        </div>
      </div>
      <div class="editLabelClass">
        <div class="searchItem">
          <span>添加新建标签</span>
          <el-input
            v-model="addNewLabel"
            maxlength="10"
            clearable
            size="small"
            placeholder="请输入新标签名称"
            show-word-limit
          ></el-input>
          <el-button type="success" @click="addNewLabelClick" size="mini"
            >新增</el-button
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitLabel" size="mini"
          >确 定</el-button
        >
        <el-button @click="editLabelShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 单个转移 -->
    <el-dialog
      title="单个1转移"
      :visible.sync="transferVisible"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="transferForm"
        :rules="rules"
        ref="transferForm"
        label-width="100px"
      >
        <el-form-item label="筛选条件：">
          <div class="screen">
            <div>姓名-{{ transferForm.fullname }}</div>
            <div>手机号码-{{ transferForm.mobile }}</div>
          </div>
        </el-form-item>
        <el-form-item label="转移给：">
          <el-select
            v-model="transferForm.staff_id"
            filterable
            placeholder="请选择"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in transferOneOptions"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tobMoveOne()" size="mini"
          >保存</el-button
        >
        <el-button @click="transferVisible = false" size="mini"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量转移 -->
    <el-dialog
      title="批量转移"
      :visible.sync="batchVisible"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="batchForm"
        :rules="rules"
        ref="batchForm"
        label-width="100px"
      >
        <el-form-item label="筛选条件：">
          <div class="screen">
            <div>负责人-{{ batchForm.fullName }}</div>
            <div>跟进状态-{{ batchForm.statusName }}</div>
          </div>
        </el-form-item>
        <div style="text-align: right">
          总计：客户数据共
          <span style="color: red">{{ batchForm.total }}</span> 条
        </div>
        <el-form-item label="转移给：">
          <el-select
            v-model="batchForm.staff_id"
            filterable
            placeholder="请选择"
            :clearable="true"
            size="mini"
            @change="$forceUpdate()"
          >
            <el-option
              v-for="item in transferNewOptions"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tobMoveMore()" size="mini"
          >保存</el-button
        >
        <el-button @click="batchVisible = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 计费说明弹窗 -->
    <el-dialog
      title="计费说明"
      :visible.sync="jifeiDialogVisible"
      class="formDialog"
      width="500px"
    >
      <div v-html="notice"></div>
    </el-dialog>

    <!-- 筛选弹窗 -->
    <el-dialog
      title="筛选条件"
      :visible.sync="screenVisible"
      class="formDialog"
      width="500px"
    >
      <div class="searchItem">
        <span class="lable">手机号码：</span>
        <el-input
          class="kd100"
          v-model="queryInfo.mobile"
          clearable
          size="small"
          placeholder="请输入学员手机号"
        ></el-input>
      </div>
      <div class="searchItem">
        <span class="lable">任务名称：</span>
        <el-select
          class="kd100"
          v-model="queryInfo.task_ids"
          filterable
          placeholder="请选择任务名称"
          :clearable="true"
          size="mini"
          @change="taskChange"
        >
          <el-option
            v-for="item in nameOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="lable">负责人：</span>
        <el-select
          class="kd100"
          v-model="queryInfo.staff_id"
          filterable
          placeholder="请选择负责人"
          :clearable="true"
          size="mini"
          @change="staffChange"
        >
          <el-option
            v-for="item in principalOptions"
            :key="item.id"
            :label="item.realname"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="searchItem">
        <span class="lable">考试</span>

        <el-input
          class="kd100"
          v-model="queryInfo.exam"
          clearable
          size="small"
          placeholder="请输入考试"
        ></el-input>
      </div>
      <div class="searchItem">
        <span class="lable">标签</span>
        <el-select
          class="kd100"
          v-model="selectTags"
          filterable
          remote
          multiple
          reserve-keyword
          placeholder="请输入关键词"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item, index) in options1"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="lable">跟进状态：</span>
        <el-select v-model="queryInfo.status" size="small" class="kd100">
          <el-option label="请选择状态" value="-1"></el-option>
          <!-- 0未联系 1已接通 2未接通 -->
          <el-option label="未联系" :value="0"></el-option>
          <el-option label="已接通" :value="1"></el-option>
          <el-option label="未接通" :value="2"></el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="lable">省份：</span>
        <el-select
          v-model="selectedProvinces"
          size="small"
          class="kd100"
          clearable
          multiple
          filterable
          @change="provinceChange"
        >
          <el-option
            v-for="(item, index) in provincesOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="lable">城市：</span>
        <el-select
          v-model="selectedCitys"
          size="small"
          class="kd100"
          clearable
          multiple
          filterable
          :disabled="selectedProvinces.length > 1"
        >
          <el-option
            v-for="(item, index) in citysOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="lable">备注：</span>
        <el-input
          class="kd100"
          v-model="queryInfo.remark"
          clearable
          size="small"
          placeholder="请输入备注信息"
        ></el-input>
      </div>
      <div class="searchItem">
        <span class="lable">导入时间</span>
        <el-date-picker
          class="kd100"
          v-model="timeFrame"
          size="small"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          @change="selectData"
          clearable
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetQuery(queryInfo.type)" size="mini"
          >重置</el-button
        >
        <el-button @click="(queryInfo.page = 1), queryTable()" size="mini"
          >搜索</el-button
        >
      </div>
    </el-dialog>

    <ImportOwnNumber
      ref="ImportOwnNumberRef"
      :task_name="task_name"
      @outerRefresh="outerRefresh"
    ></ImportOwnNumber>

    <!-- 提示 -->
    <el-tag
      type="danger"
      effect="dark"
      size="mini"
      class="last-call-zzy"
      id="last-call-zzy"
      disable-transitions
      v-show="last_call_zzy"
    >
      上次呼叫到
    </el-tag>
  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import studentApi from "@/api/student.js";
import callPhoneApi from "@/api/callphone";
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import ImportOwnNumber from "@/components/ImportOwnNumber.vue";
import callPhonePopUp from "@/components/callPhonePopUp.vue";
import qee from "qf-export-excel";
import MyButton from "@/components/MyButton.vue";
import launchSelect from "@/components/launchSelect.vue";
// 外呼学员管理
export default {
  name: "callPhone",
  components: {
    TableComponents,
    ImportOwnNumber,
    callPhonePopUp, // 呼叫弹窗组件
    MyButton,
    launchSelect,
  },
  data() {
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return {
      options: [],
      options1: [],
      apptypeOptions: [
        { label: "高职单招", value: "senioriup" },
        { label: "成人高考", value: "adultscollege" },
        { label: "成人高考高起点考试", value: "adultsgqd" },
        { label: "成人高考专升本考试", value: "adultszsb" },
      ],
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        mobile: "",
        use_app_type: "",
        status: "-1", //状态 1-已联系 0-未联系  -1全部
        type: "2", //用户类型 1-合作平台 2-自有
        province_id: "",
        city_id: "",
        remark: "",
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag: "", //标签id
        staff_id: "",
      },
      tableList: [],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        mobile: "",
        realname: "",
        id_card: "",
        remark: "",
        status: 1,
        id: "",
      },
      rules: {
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入2-6个汉字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },

      // 重置密码弹窗
      resetCodeShow: false,
      codeInfo: {
        new_password: "",
        new_password_confirmation: "",
      },
      codeRules: {
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "密码必须使用6-15位字符",
            trigger: "change",
          },
        ],
        new_password_confirmation: [
          { required: true, validator: confirmPasswordVerify, trigger: "blur" },
        ],
      },

      editLabelShow: false,
      // 已添加标签
      userLabel: [],
      userAddLabel: [],
      userDeleteLabel: [],
      // 可添加标签
      addLabel: [],
      addNewLabel: "",
      chioceUid: "",

      // 学员开课字段
      selectBuyGoodsShow: false,

      // 读取文件
      fileData: "",

      // good
      goodsNeedId: "",
      // outerVisible: false,
      fileName: "",
      excelList: [],
      timeFrame: [],
      selectTags: [],
      selectedProvinces: [],
      provincesOptions: [],
      selectedCitys: [],
      citysOptions: [],
      callDialogVisible: false,
      callStatusDialogVisible: false, // 呼叫状态弹窗
      callStatus: -1, // 呼叫状态 -1接口失败 0：通话中， 1：已挂断
      callErrorData: {},
      callSuccessData: {},
      callUser: {},
      myUser: "",
      myCallPhone: "",
      newCallPhone: "",
      changeMobileDialogVisible: false,
      kefuDialogVisible: false,
      callLogDialogVisible: false,
      callLogColumns: [
        //列数据
        { label: "主叫号码", prop: "mobile_from" },
        { label: "呼叫人", prop: "realname" },
        { label: "呼叫时间", prop: "start_at" },
        { label: "时长", prop: "time", width: 130 },
        // { label: "标签", prop: "tags", width: 200 },
        { label: "备注", prop: "remark", width: 200 },
        { label: "计费", prop: "price", width: 180, isMySelf: true },
      ],
      callData: "",
      callLogTableData: [],
      callLogQuery: {
        limit: 20,
        page: 1,
        total: 0,
      },
      jifeiDialogVisible: false,
      notice: "",
      callQueryTimer: "",
      kefuData: {},
      kefuData2: {},
      selfnumber: "",
      preciseimport: "",
      outboundcallnumber: "",
      billingzysm: "",
      nameOptions: [],
      principalOptions: [],
      transferOptions: [],
      task_name: "",
      isIndeterminate: true,
      checkAll: [],
      popoverOptions: [],
      popoverChecked: [],
      revealVisible: false,
      is_show_task: "",
      is_show_self_import_btn: "",
      role: "",
      refresh: true,
      remarkList: [],
      remarkData: {},
      userInfoId: "",
      // multipleSelection: [],
      multipleList: [],
      multipleListAll: [],
      transferForm: {},
      transferVisible: false,
      isClose: false, // 是为否关闭弹窗
      last_call_zzy: false,
      batchForm: {},
      batchVisible: false,
      outbounddcgzsm: "",
      statusOptions: [
        // 0未联系 1已接通 2未接通
        {
          value: 0,
          label: "未联系",
        },
        {
          value: 1,
          label: "已接通",
        },
        {
          value: 2,
          label: "未接通",
        },
      ],
      currentData: false,
      ownData: false,
      transferOneOptions: [],
      transferNewOptions: [],
      screenVisible: false,
      timeLock: true,
      launchStatus: true,
      queryInfoType: "2", //用户类型 1-合作平台 2-自有
    };
  },
  computed: {
    dialogType() {
      //  'this.userInfo.id',this.userInfo.uid);
      return this.userInfo.uid ? "编辑" : "新增";
    },
    isSalespersonr() {
      return this.$store.state.user.userInfo.role == "salespersonr";
    },
    StatusMap() {
      return new Map(
        this.statusOptions.map((item) => [item.value, item.label])
      );
    },
    staffMap() {
      return new Map(
        this.principalOptions.map((item) => [item.id, item.realname])
      );
    },
    transferNewMap() {
      return new Map(
        this.transferNewOptions.map((item) => [item.id, item.realname])
      );
    },
  },
  watch: {
    selectBuyGoodsShow: {
      handler(_newVal) {
        //  _newVal);
      },
    },
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          console.log("this.userInfo---1", this.userInfo);
          Object.keys(this.userInfo).forEach((key) => {
            if (typeof this.userInfo[key] == "string") {
              this.userInfo[key] = "";
            } else if (typeof this.userInfo[key] == "number") {
              this.userInfo[key] = 1;
            }
          });
          this.userInfo.uid = "";
          console.log("this.userInfo---2", this.userInfo);
        }
      },
    },
    resetCodeShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.codeInfo);
          this.$refs["codeInfoForm"].resetFields();
        }
      },
    },
    editLabelShow: {
      handler(_newVal) {
        if (!_newVal) {
          this.addNewLabel = "";
        }
      },
    },
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
  },
  created() {
    this.getTobHideMenu();
    // this.role = this.$store.state.user.userInfo.role;
    if (this.$route.query && this.$route.query.name) {
      this.queryInfo.keyword = this.$route.query.name;
    }
    if (this.$route.query && this.$route.query.id) {
      this.queryInfo.task_ids = Number(this.$route.query.id);
    }
    if (this.$route.query && this.$route.query.task_id) {
      this.queryInfo.task_ids = Number(this.$route.query.task_id);
    }
    if (this.$route.query && this.$route.query.staff_id) {
      this.queryInfo.staff_id = Number(this.$route.query.staff_id);
    }
    if (this.$route.query && this.$route.query.type) {
      this.queryInfoType = this.$route.query.type;
    }

    this.userInfoId = this.$store.state.user.userInfo.id;
    console.log("this.userInfoId---", this.userInfoId);
    this.getTobAllTask();
    this.getDic();
    this.getMe();
    this.getAreas();
    // this.getAllTags();
    this.getTobSearchTags();
    this.queryTable();
  },
  methods: {
    // 选择日期
    selectData2(e) {
      //  e);
      if (e) {
        this.queryInfo.mobile_start_time = e[0];
        this.queryInfo.mobile_end_time = e[1];
      } else {
        this.queryInfo.mobile_start_time = "";
        this.queryInfo.mobile_end_time = "";
      }
    },
    launchStatusChang(e) {
      this.launchStatus = e;

      console.log("launchStatus", this.launchStatus);
    },
    // 筛选
    screen() {
      this.screenVisible = true;
    },
    // 新增备注弹窗
    addFormClose() {
      console.log("addFormClose");
      this.queryTable();
    },
    // 当前页
    currentChange(e) {
      this.ownData = false;
      this.multipleListAll = [];
      this.multipleList = [];
      this.$refs.multipleTable.clearSelection();
      if (!this.queryInfo.staff_id) {
        this.currentData = false;
        this.$message({
          message:
            "请选择需要进行转移操作的负责人（暂不支持同时转移多个员工数据）",
          type: "error",
        });
        return;
      }

      if (e) {
        this.multipleList = this.tableList;
        this.$refs.multipleTable.toggleAllSelection();
      }
      console.log("CurrentChange", e, this.multipleList);
    },
    // 所有页
    ownChange(e) {
      if (!this.queryInfo.staff_id) {
        this.ownData = false;
        this.$message({
          message:
            "请选择需要进行转移操作的负责人（暂不支持同时转移多个员工数据）",
          type: "error",
        });
        return;
      }

      this.currentData = false;
      this.multipleListAll = [];
      this.multipleList = [];
      this.$refs.multipleTable.clearSelection();

      if (e) {
        let params = deepClone(this.queryInfo);
        params.is_export = 1;
        if (this.selectedProvinces.length > 0) {
          params.province_id = this.selectedProvinces.join(",");
        } else {
          params.province_id = "";
        }
        if (this.selectedCitys.length > 0) {
          params.city_id = this.selectedCitys.join(",");
        } else {
          params.city_id = "";
        }
        if (this.selectTags.length > 0) {
          params.tag = this.selectTags.join(",");
        } else {
          params.tag = "";
        }
        params.type = this.queryInfoType 
        callPhoneApi.userList(params).then((res) => {
          if (res.code == 200) {
            console.log("ownChange", res.data.data);
            if (res.data.data && res.data.data.length > 0) {
              this.multipleListAll = res.data.data;
              this.$refs.multipleTable.toggleAllSelection();
            }
            this.$forceUpdate(); //刷新
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        this.multipleList = [];
        this.multipleListAll = [];
        this.$refs.multipleTable.clearSelection();
      }
    },

    taskChange(e) {
      // 任务名称
      console.log("taskChange", e);
      if (e) {
        this.queryTable();
      } else {
        this.resetQuery(this.queryInfo.type);
      }
    },
    staffChange(e) {
      // 负责人
      console.log("staffChange", e);
      if (e) {
        this.queryTable();
      } else {
        this.resetQuery(this.queryInfo.type);
      }
    },

    tobMoveMore() {
      var crm_users_ids = [];
      this.multipleList.forEach((item) => {
        crm_users_ids.push(item.id);
      });

      commonApi
        .tobMoveMore({
          crm_users_ids: crm_users_ids.toString(),
          staff_id: this.batchForm.staff_id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.batchVisible = false;

            this.ownData = false;
            this.$refs.multipleTable.clearSelection();

            this.queryTable();
            this.$message({
              type: "success",
              message:
                "成功转移" +
                crm_users_ids.length +
                "条数据至" +
                this.transferNewMap.get(this.batchForm.staff_id),
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
    },
    // 批量转移
    batchTransfer() {
      var staffIdsAll = [];
      this.multipleList.forEach((item) => {
        staffIdsAll.push(item.staff_id);
      });
      var allEqual = staffIdsAll.every((val, i, arr) => val === arr[0]);
      if (!this.queryInfo.staff_id && this.multipleList.length > 1) {
        if (!allEqual) {
          this.$message({
            message:
              "请选择需要进行转移操作的负责人（暂不支持同时转移多个员工数据）",
            type: "error",
          });
          return;
        }
      }

      if (this.ownData) {
        this.multipleList = this.multipleListAll;
      }

      if (this.multipleList && this.multipleList.length > 0) {
        if (this.multipleList.length == 1 || allEqual) {
          this.batchForm.fullName = this.staffMap.get(
            this.multipleList[0].staff_id
          );
        } else {
          this.batchForm.fullName = this.staffMap.get(this.queryInfo.staff_id);
        }

        this.batchForm.statusName = this.StatusMap.get(this.queryInfo.status)
          ? this.StatusMap.get(this.queryInfo.status)
          : "全部";

        this.batchForm.total = this.multipleList.length;
        this.transferNewOptions = this.transferOptions.filter((e) => {
          return e.id !== this.queryInfo.staff_id;
        });

        this.batchForm.staff_id = "";

        this.batchVisible = true;
      } else {
        this.$message({
          message: "请勾选需要转移的数据",
          type: "error",
        });
        return;
      }
    },
    // 单个转移确认
    tobMoveOne() {
      if (!this.transferForm.staff_id) {
        this.$message({
          message: "请选择转移人",
          type: "error",
        });
        return;
      }
      commonApi
        .tobMoveOne({
          crm_users_id: this.transferForm.id,
          staff_id: this.transferForm.staff_id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.transferVisible = false;
            this.queryTable();
            this.$message({
              type: "success",
              message: "转移成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
    },
    // 单个转移
    transfer(row) {
      console.log("transfer", row);

      this.transferOneOptions = this.transferOptions.filter((e) => {
        return e.id !== row.staff_id;
      });
      console.log("transferOneOptions", this.transferOneOptions);

      this.transferForm = row;
      this.transferForm.staff_id = "";
      this.transferVisible = true;
    },
    // 勾选
    handleSelectionChange(val) {
      // this.multipleSelection = val.map((x) => x.id);
      this.multipleList = val;
    },

    getTobRemarks(crm_users_id) {
      commonApi.getTobRemarks({ crm_users_id: crm_users_id }).then((res) => {
        if (res.code === 200) {
          res.data.data.forEach((item) => {
            item.editStatus = false;
          });
          this.remarkList = res.data.data;
          this.$forceUpdate(); //刷新
        }
      });
    },
    addRemark() {
      console.log("addRemark", this.remarkData);
      var that = this;
      if (that.timeLock) {
        that.timeLock = false;
        commonApi
          .remarkDo({
            crm_users_id: this.remarkData.crm_users_id,
            id: "0",
            remark: this.remarkData.remark,
          })
          .then((res) => {
            setTimeout(() => {
              that.timeLock = true;
            }, 500);
            if (res.code === 200) {
              this.remarkData.remark = "";
              this.getTobRemarks(this.remarkData.crm_users_id);
              this.$message({
                type: "success",
                message: "添加成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
      }
    },
    // 保存编辑备注
    remarkSave(e) {
      commonApi
        .remarkDo({
          crm_users_id: this.remarkData.crm_users_id,
          id: e.id,
          remark: e.remark,
        })
        .then((res) => {
          if (res.code === 200) {
            this.getTobRemarks(this.remarkData.crm_users_id);
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });

      this.remarkList.forEach((item) => {
        item.editStatus = false;
      });
    },
    // 取消编辑备注
    remarkCancel() {
      this.getTobRemarks(this.remarkData.crm_users_id);
      this.remarkList.forEach((item) => {
        item.editStatus = false;
      });
    },
    // 删除备注
    remarkDelete(e) {
      console.log("remarkDelete", e);
      this.$confirm("是否删除这条备注?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.remarkList.splice(f, 1);
          commonApi
            .remarkDel({ crm_users_id: this.remarkData.crm_users_id, id: e.id })
            .then((res) => {
              if (res.code === 200) {
                this.getTobRemarks(this.remarkData.crm_users_id);
              }
            });

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑备注
    remarkEdit(e, f) {
      console.log("remarkEdit", e, f);
      this.remarkList.forEach((item, index) => {
        if (index == f) {
          item.editStatus = true;
        } else {
          item.editStatus = false;
        }
      });
    },
    // 导出Excel
    downloadExcel() {
      if (!this.queryInfo.task_ids) {
        this.$message({
          message: "请选择需要导出的任务名称（暂不支持同时导出多个任务数据）",
          type: "error",
        });
        return;
      }

      let params = deepClone(this.queryInfo);
      params.is_export = 1;
      if (this.selectedProvinces.length > 0) {
        params.province_id = this.selectedProvinces.join(",");
      } else {
        params.province_id = "";
      }
      if (this.selectedCitys.length > 0) {
        params.city_id = this.selectedCitys.join(",");
      } else {
        params.city_id = "";
      }
      if (this.selectTags.length > 0) {
        params.tag = this.selectTags.join(",");
      } else {
        params.tag = "";
      } 
      params.type = this.queryInfoType 
      callPhoneApi.userList(params).then((res) => {
        if (res.code == 200) {
          console.log("ownChange", res.data.data);
          var userList = res.data.data;

          userList.forEach((item) => {
            if (item.type == 1) {
              item.typename = "平台号码";
            } else {
              item.typename = "自有号码";
            }
            if (item.tags && item.tags.length > 0) {
              item.tagsname = item.tags.toString();
            }
            // 0未联系 1已接通 2未接通
            if (item.status == 0) {
              item.statusname = "未联系";
            } else if (item.status == 1) {
              item.statusname = "已接通";
            } else {
              item.statusname = "未接通";
            }
          });
          var titleList = [];
          if (userList[0].type_is_show) {
            titleList.push({ title: "号码类型", key: "typename" });
          }
          titleList.push({ title: "任务名称", key: "task_name" });
          if (this.queryInfoType == 2 && userList[0].fullname_is_show) {
            titleList.push({ title: "姓名", key: "fullname" });
          }
          titleList.push({ title: "手机号", key: "mobile" });
          if (this.queryInfoType == 2 && userList[0].score_is_show) {
            titleList.push({ title: "分数", key: "score" });
          }
          if (userList[0].app_type_is_show || this.queryInfoType == 1) {
            titleList.push({ title: "所属考试", key: "exam" });
          }
          if (userList[0].province_name_is_show || this.queryInfoType == 1) {
            titleList.push({ title: "省份", key: "province_name" });
          }
          if (userList[0].city_name_is_show || this.queryInfoType == 1) {
            titleList.push({ title: "市", key: "city_name" });
          }
          titleList.push({ title: "标签", key: "tagsname" });
          titleList.push({ title: "跟进状态", key: "statusname" });
          titleList.push({ title: "备注", key: "remark" });
          if (userList[0].import_at_is_show || this.queryInfoType == 1) {
            titleList.push({ title: "导入时间", key: "import_at" });
          }
          titleList.push({ title: "负责人", key: "staff_name" });
          titleList.push({ title: "最近一次呼叫时间", key: "last_call_at" });

          var fileName =
            "自有号码数据" + this.getYesterDate() + this.randomRange(0, 1000);
          qee(titleList, userList, fileName);

          this.$forceUpdate(); //刷新
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 日期
    getYesterDate() {
      var currentDate = new Date();
      var yesterDate = currentDate.getTime() - 24 * 60 * 60 * 1000;
      var oDate = new Date(yesterDate);
      var oYear = oDate.getFullYear();
      var oMonth = oDate.getMonth() + 1;
      var oDay = oDate.getDate();
      var oTime = oYear + this.prefixZero(oMonth) + this.prefixZero(oDay);
      return oTime;
    },
    // 随机数
    prefixZero(num) {
      if (parseInt(num) < 10) {
        num = "0" + num;
      }
      return num + "";
    },
    // 随机数
    randomRange(min, max) {
      // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;
    },
    // 关闭导入弹窗刷新列表
    outerRefresh(e) {
      console.log("outerRefresh", e);
      if (e) {
        this.queryTable();
      }
    },
    async getTobHideMenu() {
      await goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          console.log("getTobHideMenu", res.data.is_show_task);
          this.is_show_task = res.data.is_show_task;
        }
      });
    },

    confirm() {
      commonApi
        .tobUpDateField({
          self_show_field: this.popoverChecked.toString(),
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.revealVisible = false;
            this.queryTable();
          }
        });
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.popoverOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.popoverOptions.length;
    },
    handleCheckAllChange(val) {
      console.log("handleCheckAllChange", val);
      if (val) {
        this.popoverChecked = [];
        this.popoverOptions.forEach((itemA) => {
          this.popoverChecked.push(itemA.field);
        });
      } else {
        this.popoverChecked = [];
      }
      this.checkAll = val;
      this.isIndeterminate = false;
    },

    openImport() {
      // this.outerVisible = true;
      this.task_name = this.getYesterDate() + this.formatDateTime();
      this.$refs.ImportOwnNumberRef.show();
      this.$refs.ImportOwnNumberRef.getTobAllAcCount();
    },
    formatDateTime() {
      var result = new Date().getTime();
      return result;
    },
    handleClick(event) {
      console.log("handleClick", event);
      if (event) {
        this.queryTable();
      }
    },
    getTobAllTask() {
      commonApi.getTobAllTask().then((res) => {
        if (res.code === 200) {
          this.nameOptions = res.data;
        }
      });
    },
    callDialogClose() {
      if (this.callQueryTimer) {
        clearInterval(this.callQueryTimer);
        this.callQueryTimer = "";
      }
    },
    getDic() {
      commonApi.getInfoToName({ name: "outwardcal" }).then((res) => {
        console.log("1----", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "billinginstructions") {
              this.notice = item.value;
            } else if (item.key == "teacher") {
              this.kefuData.qrcode = item.flag;
              let t = item.value.split("_");
              this.kefuData.teacher_name = t[0];
              this.kefuData.teacher_mobile = t[1];
              console.log(this.kefuData);
            } else if (item.key === "selfnumber") {
              this.selfnumber = item.value;
            } else if (item.key === "preciseimport") {
              this.preciseimport = item.value;
            } else if (item.key === "outboundcallnumber") {
              this.outboundcallnumber = item.value;
            }
          });
        }
      });

      commonApi.getInfoToName({ name: "outwardcalsm" }).then((res) => {
        console.log("2----", res.data);

        res.data.forEach((item) => {
          if (item.key == "billingzysm") {
            this.billingzysm = item.value;
          }
          if (item.key == "outbounddcgzsm") {
            this.outbounddcgzsm = item.value;
          }
        });
      });
    },
    async openCallLogs(row) {
      this.callData = row;
      const res = await this.getCallLogs(row.id);
      if (res) {
        this.callLogDialogVisible = true;
      }
    },
    // 获取通话记录
    async getCallLogs(id) {
      const res = await callPhoneApi.getTobCrmLog({ crm_user_id: id });
      if (res.code === 200) {
        this.callLogTableData = res.data.data;
        this.callLogQuery.total = res.data.total;
        return true;
      } else {
        this.$message.error(res.message);
        return false;
      }
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.myUser = res.data;
        this.role = res.data.role;
        // console.log('getMe',res.data.role)
      }
    },
    provinceChange(e) {
      console.log(e);
      if (e.length == 1) {
        this.getAreaChild(e[0]);
      } else if (e.length > 1) {
        this.selectedCitys = [];
      }
    },
    async getAreaChild(id) {
      if (this.selectedProvinces.length == 1) {
        const res = await commonApi.getCitys({ id });
        if (res.code === 200) {
          this.citysOptions = res.data;
        }
      }
    },
    async getAreas() {
      const res = await commonApi.getProvinces();
      if (res.code === 200) {
        this.provincesOptions = res.data;
      }
    },
    async getTobSearchTags() {
      const res = await commonApi.getTobSearchTags({ common_tag_type: 1 });
      this.options1 = res.data.data;
    },
    // async getAllTags() {
    //   const res = await studentApi.tobTagsList({ page: 1, limit: 10000 });
    //   this.options1 = res.data.data;
    // },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobGoodList({ good_name: companyName });
          this.options = res.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobTagsList({ name: companyName });
          this.options1 = res.data.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 列表数据
    async queryTable(_type) {
      this.currentData = false;
      this.isClose = false;
      this.last_call_zzy = false;
      let params = deepClone(this.queryInfo);

      if (this.selectedProvinces.length > 0) {
        params.province_id = this.selectedProvinces.join(",");
      } else {
        params.province_id = "";
      }
      if (this.selectedCitys.length > 0) {
        params.city_id = this.selectedCitys.join(",");
      } else {
        params.city_id = "";
      }
      if (this.selectTags.length > 0) {
        params.tag = this.selectTags.join(",");
      } else {
        params.tag = "";
      }
      params.type = this.queryInfoType 
      callPhoneApi.userList(params).then((res) => {
        if (res.code == 200) {
          this.queryInfo.total = res.data.total;
          this.tableList = res.data.data;

          this.is_show_self_import_btn = res.data.is_show_self_import_btn;
          this.kefuData2 = res.data.group_info;
          this.principalOptions = res.data.staff_list;

          this.transferOptions = res.data.staff_list.filter((e) => {
            return e.id !== this.userInfoId;
          });

          this.popoverOptions = res.data.all_self_show_field;

          this.popoverChecked = [];
          res.data.all_self_show_field.forEach((item) => {
            if (item.is_selected) {
              this.popoverChecked.push(item.field);
            }
          });
          if (
            this.popoverChecked.length == res.data.all_self_show_field.length
          ) {
            this.checkAll = true;
          } else {
            this.checkAll = false;
          }
          this.isIndeterminate =
            this.popoverChecked.length > 0 &&
            this.popoverChecked.length < this.popoverOptions.length;
          if (this.ownData) {
            this.$refs.multipleTable.toggleAllSelection();
          }
          // 拨号时是否下一页第一个数据
          if (this.callUser.$index === 10) {
            this.callUser.$index = 0;
            this.callUser = {
              ...this.tableList[this.callUser.$index],
              $index: this.callUser.$index,
            };
          }

          // 小屏筛选隐藏
          this.screenVisible = false;
          this.$forceUpdate(); //刷新
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 打开客服弹窗
    openKefu() {
      this.callStatusDialogVisible = false;
      this.kefuDialogVisible = true;
    },
    // 外呼
    async callPhoneOpen(row = "", index) {
      await this.getMe();
      if (row) {
        // deepClone(row)
        this.callUser = row; 
        this.callUser.$index = index;  
      }

      // this.callStatusDialogVisible = true;
      this.last_call_zzy = false;
      this.isClose = false;
      this.callDialogVisible = true;
      // return;
      // if (this.myUser.is_called == 1 || !row) {
      //   const res = await callPhoneApi.callPhone({ id: this.callUser.id });
      //   if (res.code === 200) {
      //     this.callSuccessData.bindId = res.data.bindId;
      //     this.callSuccessData.crm_id = res.data.crm_id;
      //     // 打开呼叫弹窗
      //     this.callStatusDialogVisible = true;
      //     this.callStatus = 0;
      //     this.startCallStatusQuery();
      //   } else if (res.code === 402) {
      //     this.callErrorData = res.data;
      //     this.callStatusDialogVisible = true;
      //     this.callStatus = -1;
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // }
    },
    // 关闭呼叫弹窗
    closeCallPop(e) {
      this.callDialogVisible = false;
      this.queryTable();
      //到的是一个数组， 第几个就是第几行元素的dom
      const rowList = Array.from(
        this.$refs.multipleTable.$el.getElementsByClassName("el-table__row")
      );
      // console.log('rowList', rowList);
      // console.log('this.callUser.$index', this.callUser.$index);
      // console.log('tipDom', document.getElementById("last-call-zzy"));
      const tipDom = document.querySelector(".last-call-zzy");
      rowList[this.callUser.$index].appendChild(tipDom);
      this.last_call_zzy = true;
      tipDom.style.top = rowList[this.callUser.$index].offsetTop + "px";
      tipDom.style.left = 10 + "px";
      this.isClose = true;
      // 激活样式
      this.tableRowClassName(this.callUser.$index);
      if (e === "kefu") {
        this.openKefu();
      }
    },
    // 开启呼叫状态轮询
    startCallStatusQuery() {
      if (this.callQueryTimer) {
        clearInterval(this.callQueryTimer);
        this.callQueryTimer = "";
      }
      this.callQueryTimer = setInterval(async () => {
        let res = await callPhoneApi.callStatusQuery({
          crm_id: this.callSuccessData.crm_id,
          bindId: this.callSuccessData.bindId,
        });
        if (res.code === 200) {
          this.callSuccessData.call_duration = res.data.call_duration;
          this.callSuccessData.call_duration_txt = res.data.call_duration_txt;
          this.callSuccessData.compute_time = res.data.compute_time;
          this.callSuccessData.compute_ceil_price = res.data.compute_ceil_price;
          this.callSuccessData.compute_total_price =
            res.data.compute_total_price;
          this.callSuccessData.is_pay = res.data.is_pay;
          this.callSuccessData.import_user_first_free_txt =
            res.data.import_user_first_free_txt;
          if (res.data.status == 1) {
            this.callStatus = 1; // 已挂断
            // 已挂断
            clearInterval(this.callQueryTimer);
            this.callQueryTimer = "";
          }
        } else {
          clearInterval(this.callQueryTimer);
          this.callQueryTimer = "";
        }
      }, 5000);
    },
    changeMobile() {
      this.myCallPhone = this.myUser.call_phone
        ? this.myUser.call_phone
        : this.myUser.mobile;
      this.changeMobileDialogVisible = true;
    },
    async changeMobileCheck() {
      if (!this.newCallPhone) {
        this.$message.error("新号码不能为空");
        return;
      }
      if (this.newCallPhone.length !== 11) {
        this.$message.error("新号码长度必须为11位");
        return;
      }
      const res = await callPhoneApi.updateAccountCallPhone({
        id: this.myUser.id,
        call_phone: this.newCallPhone,
      });
      console.log(res);
      if (res.code === 200) {
        this.$message.success("更新成功");
        this.myUser.call_phone = this.newCallPhone;
        this.changeMobileDialogVisible = false;
      } else {
        this.$message.error(res.message);
      }
    },
    // 开始呼叫
    async callUserMobile() {
      if (!this.myUser.call_phone) {
        this.myUser.call_phone = this.myUser.mobile;
      }
      const res = await callPhoneApi.updateAccountCallPhone({
        id: this.myUser.id,
        call_phone: this.myUser.call_phone,
      });
      console.log(res);
      if (res.code === 200) {
        this.callDialogVisible = false;
        await this.callPhoneOpen();
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      // if (row.id) {
      //   Object.assign(this.userInfo, row);
      // }
      this.remarkList = [];
      this.remarkData = {};
      commonApi.getTobRemarks({ crm_users_id: row.id }).then((res) => {
        if (res.code === 200) {
          console.log("getTobRemarks", res.data.data);
          res.data.data.forEach((item) => {
            item.editStatus = false;
          });

          this.remarkList = res.data.data;

          this.remarkData.crm_users_id = row.id;
          this.remarkData.remark = "";
          this.addFormShow = true;
        }
      });
    },
    // 添加｜｜修改数据
    async addUserRemark() {
      if (!this.userInfo.remark) {
        this.$message({
          type: "error",
          message: "备注不能为空!",
        });
        return;
      }
      console.log(this.userInfo);
      const res = await callPhoneApi.updateUser({
        id: this.userInfo.id,
        remark: this.userInfo.remark,
      });
      if (res.code === 200) {
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.addFormShow = false;
        this.queryTable();
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    // 设置新密码
    resetCode(row) {
      this.resetCodeShow = true;
      this.codeInfo.uid = row.uid;
    },
    editCode(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await studentApi.passwordOperation(this.codeInfo);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改密码成功!",
            });
          } else {
            this.$message.error(res.message);
          }
          this.resetCodeShow = false;
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 添加、编辑标签
    async editLabel(row) {
      this.chioceUid = row.id;
      const res = await studentApi.studentsTags({ uid: row.id, type: 1 });
      if (res.code == 200) {
        this.editLabelShow = true;
        this.addLabel = res.data.data;
        this.userLabel = res.data.own;
      } else {
        this.$message.error(res.message);
      }
    },
    // 添加新标签
    async addNewLabelClick() {
      const res = await studentApi.tobTagsAdd({ name: this.addNewLabel });
      if (res.code == 200) {
        this.$message.success("新增标签成功");
        this.addNewLabel = "";
        this.userLabel.push(res.data);
        let tags = [];
        this.userLabel.forEach((item) => {
          tags.push(item.id);
        });
        const res1 = await callPhoneApi.updateUser({
          id: this.chioceUid,
          tag_id: tags.join(","),
        });
        if (res1.code == 200) {
          this.editLabelShow = true;
          // this.addLabel = res1.data.data
          this.userLabel.forEach((item, index) => {
            this.addLabel.forEach((item1, index1) => {
              if (item.id == item1.id) {
                this.addLabel.splice(index1, 1);
              }
            });
          });
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 现有标签选择
    tagAddLabel(tag) {
      this.addLabel.forEach((item, index) => {
        //  'item',item);
        if (item.id == tag.id) {
          //  'item',item);
          this.addLabel.splice(index, 1);
        }
      });
      if (!this.userLabel.length) {
        this.userLabel.push(tag);
        this.userAddLabel.push(tag);
        return;
      }
      const _flag = this.userLabel.some((item, index) => {
        return item.id == tag.id;
      });
      if (!_flag) {
        //  1111);
        this.userLabel.push(tag);
        this.userAddLabel.push(tag);
      }
    },
    // 删除绑定标签
    deleteLabel(tag) {
      this.userLabel.forEach((item, index) => {
        if (item.id == tag.id) {
          this.userLabel.splice(index, 1);
        }
      });
      let flag = 0;
      this.userAddLabel.forEach((item, index) => {
        if (item.id == tag.id) {
          this.userAddLabel.splice(index, 1);
          flag = 1;
        }
      });
      let allFlag = 0;
      allFlag = this.addLabel.forEach((item, index) => {
        //  'item',item);
        return item.id == tag.id;
      });
      if (!allFlag) {
        this.addLabel.push(tag);
      }
      if (!flag) {
        const _flag = this.userLabel.some((item, index) => {
          return item.id == tag.id;
        });
        if (!_flag) {
          this.userDeleteLabel.push(tag);
        }
      }
    },
    // 用户新增标签
    submitLabel() {
      //  'userAddLabel',this.userAddLabel,'userDeleteLabel',this.userDeleteLabel);

      // let _addId = this.userAddLabel.map((item,index)=>{
      //   return item.id
      // })
      let _deleteId = this.userLabel.map((item, index) => {
        return item.id;
      });
      let _proArray = [];
      // if(_addId.length){
      _proArray.push(
        callPhoneApi.updateUser({
          id: this.chioceUid,
          tag_id: _deleteId.join(","),
        })
      );
      // }
      // _proArray.push(studentApi.studentsTagsDel({
      //   uid:this.chioceUid,
      //   tag_id:_deleteId.join(",")
      // }))
      Promise.all(_proArray).then((res) => {
        this.queryTable(this.queryInfo.type).then((res) => {
          this.$message.success("标签更新成功");
        });
        this.userAddLabel = [];
        this.userDeleteLabel = [];
        this.editLabelShow = false;
      });
    },

    // 开通会员
    buyGoodsBtn(row) {
      this.selectBuyGoodsShow = true;
      this.goodsNeedId = row.uid;
    },

    // 跳转已开课程
    skip(row) {
      this.$router.push({
        path: "/studentDetail",
        query: {
          name: row.username,
          realname: row.realname,
          uid: row.uid,
        },
      });
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      console.log("e", e);
      this.isClose = false;
      this.last_call_zzy = false;
      this.queryInfo.page = e;
      this.queryTable();
    },

    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
      //  fileList);
      this.fileData = file; // 保存当前选择文件
      this.fileName = file.name;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      let that = this;
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          console.log("data---", data);
          const workbook = that.XLSX.read(data, {
            type: "binary",
            // cellNF:true,
            raw: true,
          });
          console.log("workbook---", workbook);
          // if (workbook.SheetNames.length >= 1) {
          //   this.$message.success("表格导入成功")
          // }
          const wsname = workbook.SheetNames[0]; //取第一张表
          console.log("wsname---", wsname);
          const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log("ws---", ws);
          that.outputs = []; //清空接收数据
          let _list = [];
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              fullname: ws[i]["姓名（非必填）"],
              mobile: ws[i]["手机号（必填）"],
              score: ws[i]["分数（非必填）"],
              app_type:
                ws[i][
                  "所属考试(非必填，也可选择下列考试名称填写方便系统识别：高职单招考试，成人高考，成人高考高起点考试，成人高考专升本考试)"
                ],
              province: ws[i]["省份（非必填）"],
              city: ws[i]["市（非必填）"],
              remark: ws[i]["备注（非必填）"],
            };
            _list.push(sheetData);
          }
          if (_list.length) {
            this.excelList = _list;
            console.log("this.excelList", this.excelList);
          } else {
            this.$message.error("请先填入数据");
          }

          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    resetQuery(_type = 2) {
      this.multipleList = [];
      this.multipleListAll = [];
      this.currentData = false;
      this.ownData = false; 
      this.timeFrame = [];
      this.timeFrame2 = [];
      this.selectedProvinces = [];
      this.selectedCitys = [];
      this.selectTags = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        mobile: "",
        use_app_type: "",
        status: "-1", //状态 1-已联系 0-未联系
        type: _type, //用户类型 1-合作平台 2-自有
        province_id: "",
        city_id: "",
        remark: "",
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag: "", //标签id
        staff_id: "",
      }; 
      this.queryTable();
      this.$refs.multipleTable.clearSelection();
    },
    // 选择日期
    selectData(e) {
      //  e);
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },

    exportExcel() {
      window.open(
        "https://img2.meite.com/question/import/selfcallimport230605.xls",
        "_blank"
      );
      // var titleList = [
      //   { title: '手机号（必填）', key: "mobile" },
      //   { title: '所属考试(可为空，也可选择下列考试名称填写方便系统识别：高职单招考试，成人高考，成人高考高起点考试，成人高考专升本考试)', key: 'apptype' },
      //   { title: '省份（可为空）', key: 'province' },
      //   { title: '市（可为空）', key: 'city' },
      //   { title: '备注（可为空）', key: 'remark' },
      // ]
      // var dataSource = [{ mobile: '15712345678', apptype: '高职单招考试', province: '湖南', city: '长沙', remark: '备考通' }]
      // var fileName = "自有号码导入模版"
      // qee(titleList, dataSource, fileName)
    },
    skipImportRecord(row) {
      this.$router.push({
        path: "/importRecord",
        query: {
          type: 1,
        },
      });
    },
    skipImportRecordDetail(recordId) {
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: recordId,
          type: 1,
        },
      });
    },
    // openImport(row) {
    //   this.outerVisible = true;
    // },
    importFile() {
      if (this.excelList.length) {
        callPhoneApi
          .importCallPhone({ data: JSON.stringify(this.excelList) })
          .then((res) => {
            if (res.code == 200) {
              // this.$message.success("导入成功，请查看导入记录")
              this.fileName = "";
              this.excelList = [];
              this.queryInfo.page = 1;
              this.queryTable();
              // this.outerVisible = false;
              // this.$confirm('数据导入成功', '提示', {
              //     confirmButtonText: '查看导入数据'
              //   }).then(() => {
              //     this.skipImportRecord()
              //   })
              this.$alert("导入完成", "提示", {
                confirmButtonText: "查看导入数据",
                callback: (action) => {
                  if (action == "confirm") {
                    this.skipImportRecordDetail(res.data.record_id);
                  }
                },
              });
            } else {
              this.$message.error(res.message);
            }
          });
      } else {
        this.$message.error("请先填入数据");
      }
    },
    excelImport() {
      this.fileName = "";
      this.excelList = [];
      // this.outerVisible = false
      this.outerVisible = false;
    },
    // 呼叫下一位
    async callNext() {
      await this.getMe();
      console.log("呼叫下一位");
      if (
        (this.queryInfo.page - 1) * this.queryInfo.limit +
          this.callUser.$index +
          1 ===
        this.queryInfo.total
      ) {
        this.$message("在本次筛选条件下，已无下一个叫码");
        return;
      }
      this.callUser.$index++;
      if (this.callUser.$index === 10) {
        this.queryInfo.page++;
        this.handleCurrentChange(this.queryInfo.page);
      } else {
        this.callUser = {
          ...this.tableList[this.callUser.$index],
          $index: this.callUser.$index,
        };
        console.log(this.callUser, this.callUser.fullname);
      }
    },
    // 当前呼叫行添加底色
    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.callUser.$index && this.isClose) {
        return "last-call-row";
      }
      if ((rowIndex + 1) % 2 == 0) {
        return "warning-row-color";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table .last-call-row {
  background: #f0f9eb;
}
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
    }
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  // .operationItem {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: rgb(87, 87, 239);
  // }
  // .operationItem:hover {
  //   color: red;
  // }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}

/deep/ .remarkList {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  max-height: 300px;
  overflow-y: scroll;
  .remarkItem {
    border-bottom: 1px solid #ddd;
    padding: 10px 0;
    .editRemark {
      margin-bottom: 10px;
    }
    .remark {
      font-size: 16px;
      line-height: 140%;
      padding: 0 20px;
    }
    .name {
      font-size: 14px;
      line-height: 140%;
      text-align: center;
      color: #919191;
      padding-top: 10px;
    }
    .bt {
      text-align: right;
      .el-button {
        padding: 0;
      }
    }
  }
}

/deep/.screen {
  line-height: 24px;
  padding: 10px;
  border: 1px solid #ddd;
}
/deep/.sxBox {
  position: relative;
  padding-left: 15px;
  .screenShow {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;
    display: none;
  }
}

@media (max-width: 979px) {
  /deep/.el-dialog {
    width: 100% !important;
  }

  /deep/.el-form-item__label {
    float: none !important;
  }
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/.querySearch {
    display: none !important;
  }
  /deep/.screenShow {
    display: block !important;
  }

  /deep/.searchItem .lable {
    display: block !important;
    margin: 5px 0;
  }

  /deep/.kd100 {
    width: 100% !important;
  }
}

/deep/.el-popover__reference {
  color: #846ffd !important;
  border-color: #d3cafe !important;
}
.last-call-zzy {
  position: absolute;
  background: #f40;
  color: #ffffff;
  top: 0px;
  left: 0px;
  z-index: 499;
}

/deep/.el-button--text {
  padding: 8px 10px;
}
/deep/.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
/deep/.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
</style>
